import React from 'react';
import { BrButton } from '@govbr-ds/react-components';
import IdentificacaoBasica from 'components/IdentificacaoBasica/IdentificacaoBasica';
import StepFormAccordion from 'components/stepFormAccordion/stepFormAccordion';
import { IIdentificacaoBasica } from 'interfaces/IIdentificacaoBasica';
import styles from './stepFormAccordionConfig.module.scss';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useBackEndRequests } from 'pages/components/lib/backEndRequests';
import { Tooltip } from 'react-tooltip';

interface StepFormAccordionConfigProps {
  step: number;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  stepUmContent?: React.ReactNode;
  stepDoisContent: React.ReactNode;
  stepTresContent: React.ReactNode;
  stepQuatroContent: React.ReactNode;
}

function StepFormAccordionConfig({
  step,
  setStep,
  stepUmContent,
  stepDoisContent,
  stepTresContent,
  stepQuatroContent,
}: Readonly<StepFormAccordionConfigProps>) {
  const { getIdentificacaoBasica } = useBackEndRequests();

  const userCpfCnpj = sessionStorage.getItem('userCpfCnpj');

  const { data: idBasicaData, isLoading } = useQuery<IIdentificacaoBasica, AxiosError>({
    queryKey: ['idBasicaQuery', userCpfCnpj],
    queryFn: () => getIdentificacaoBasica(userCpfCnpj || ''),
    refetchOnWindowFocus: false,
  });

  return (
    <>
      {step >= 1 && (
        <StepFormAccordion
          title='CFEM - Informações do emitente'
          subTitle='Identificação do emitente'
          stepAtual={step}
          stepFormulario={1}
        >
          <Tooltip id='tooltip-info-emitente' place='bottom' clickable className={styles.tooltip} variant='info'>
            <div className={styles.tooltipText}>
              O sistema Arrecadação - CFEM utiliza automaticamente os dados cadastrais do Sistema de Dados Cadastrais
              (SDC) da ANM. Caso as informações apresentadas em tela não estejam corretas, verifique e atualize seu
              cadastro acessando o módulo Dados Cadastrais no{' '}
              <a
                href='https://app.anm.gov.br/SCA/Site/Login.aspx?ReturnUrl=https%3A%2F%2Fapp.anm.gov.br%2Fprotocol'
                target='_blank'
              >
                Protocolo Digital
              </a>
              .
            </div>
          </Tooltip>
          <div data-tooltip-id='tooltip-info-emitente'>
            {stepUmContent || (
              <IdentificacaoBasica declaranteData={idBasicaData} isDeclaranteDataLoading={isLoading} noBorder />
            )}
          </div>
        </StepFormAccordion>
      )}

      {step >= 2 && (
        <StepFormAccordion
          title='CFEM - Dados do recolhimento'
          subTitle='Informações básicas para a emissão da CFEM'
          stepAtual={step}
          stepFormulario={2}
        >
          {stepDoisContent}

          {step !== 2 && step !== 5 && (
            <div className={styles.edit}>
              <BrButton secondary circle icon='edit' onClick={() => setStep(2)} />
            </div>
          )}
        </StepFormAccordion>
      )}

      {step >= 3 && (
        <StepFormAccordion
          title='CFEM - Dados das operações'
          subTitle='Informações relacionadas às bases de cálculo'
          stepAtual={step}
          stepFormulario={3}
        >
          {stepTresContent}
          {step !== 3 && step !== 5 && (
            <div className={styles.edit}>
              <BrButton secondary circle icon='edit' onClick={() => setStep(3)} />
            </div>
          )}
        </StepFormAccordion>
      )}

      {step >= 4 && (
        <StepFormAccordion
          title='CFEM - Guia de recolhimento'
          subTitle='Informações relacionadas à guia de recolhimento'
          stepAtual={step}
          stepFormulario={step}
        >
          {stepQuatroContent}
          {step !== 4 && step !== 5 && (
            <div className={styles.edit}>
              <BrButton secondary circle icon='edit' onClick={() => setStep(4)} />
            </div>
          )}
        </StepFormAccordion>
      )}
    </>
  );
}

export default StepFormAccordionConfig;
